export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const SET_LOGIN_VISIBILITY = "SET_LOGIN_VISIBILITY";

export const LOAD_NOTIFICATIONS = "LOAD_NOTIFICATIONS";
export const NOTIFICATIONS_LOADED = "NOTIFICATIONS_LOADED";
export const TOGGLE_NOTIFICATIONS = "TOGGLE_NOTIFICATIONS";
export const NOTIFICATION_PUSHED = "NOTIFICATION_PUSHED";
export const NOTIFICATION_MARK_AS_READ = "NOTIFICATION_MARK_AS_READ";
export const NOTIFICATION_MARK_AS_READ_ALL = "NOTIFICATION_MARK_AS_READ_ALL";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";
export const NOTIFICATION_REMOVE_FROM_TOASTS = "NOTIFICATION_REMOVE_FROM_TOASTS";

export const CONVERSATIONS_LOADED = "CONVERSATIONS_LOADED";
export const CONVERSATIONS_LOADING = "CONVERSATIONS_LOADING";
export const NEW_CONVERSATION = "NEW_CONVERSATION";
export const SELECT_CONVERSATION = "SELECT_CONVERSATION";
export const MESSAGE_SEND = "MESSAGE_SEND";
export const MESSAGE_SENDING = "MESSAGE_SENDING";
export const MESSAGE_RECEIVED = "MESSAGE_RECEIVED";
export const MARK_MESSAGES_AS_READ = "MARK_MESSAGES_AS_READ";
export const TOGGLE_CHAT = "TOGGLE_CHAT";
export const CHAT_DISCONNECTED = "CHAT_DISCONNECTED";
export const CHAT_CONNECTED = "CHAT_CONNECTED";

export const PUSH_ALERT = "PUSH_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

export const API = "API";
export const API_START = "API_START";
export const API_END = "API_END";
export const API_ERROR = "API_ERROR";

export const CACHE_IMAGE = "CACHE_IMAGE";
export const FLUSH_IMAGE = "FLUSH_IMAGE";
export const FLUSH_ALL = "FLUSH_ALL";

export const TUTORIAL_GO = "TUTORIAL_GO";
export const TUTORIAL_STOP = "TUTORIAL_STOP";
export const TUTORIAL_STEP = "TUTORIAL_STEP";

export const OVERLAY_SET_DATA = "OVERLAY_SET_DATA";
export const OVERLAY_SET_SHOW = "OVERLAY_SET_SHOW";

export const MODAL_SET_DATA = "MODAL_SET_DATA";
export const MODAL_SET_SHOW = "MODAL_SET_SHOW";

export const SET_PAGE_STATE = "SET_PAGE_STATE";
export const CLEAR_PAGE_STATE = "CLEAR_PAGE_STATE";

// Trainingplan
export const TP_SET = "TP_SET";
export const TP_INIT_PLAN = "TP_INIT_PLAN";
export const TP_SET_CAPACITIES = "TP_SET_CAPACITIES";

export const TP_SET_USERS = "TP_SET_USERS";
export const TP_ADD_USER = "TP_ADD_USER";
export const TP_REMOVE_USER = "TP_REMOVE_USER";
export const TP_UPDATE_USER = "TP_UPDATE_USER";

export const TP_SET_PSEUDO_GROUPS = "TP_SET_PSEUDO_GROUPS";
export const TP_SET_GROUPS = "TP_SET_GROUPS";
export const TP_ADD_GROUP = "TP_ADD_GROUP";
export const TP_REMOVE_GROUP = "TP_REMOVE_GROUP";
export const TP_UPDATE_GROUPS = "TP_UPDATE_GROUPS";

export const TP_SET_TRAINERS = "TP_SET_TRAINERS";
export const TP_ADD_TRAINER = "TP_ADD_TRAINER";
export const TP_REMOVE_TRAINER = "TP_REMOVE_TRAINER";
export const TP_UPDATE_TRAINER = "TP_UPDATE_TRAINER";
export const TP_UPDATE_TAGS = "TP_UPDATE_TAGS";
export const TP_UPDATE_SLOTS = "TP_UPDATE_SLOTS";

export const TP_SET_DISPLAY = "TP_SET_DISPLAY";
export const TP_SET_DEMO = "TP_SET_DEMO";
export const TP_SET_IMPORTS = "TP_SET_IMPORTS";
export const TP_SET_SETTINGS = "TP_SET_SETTINGS";
export const TP_SET_COLSIZES = "TP_SET_COLSIZES";
export const TP_SET_CELLSTATUS = "TP_SET_CELLSTATUS";
export const TP_RESET = "TP_RESET";

export const TP_SET_OVERLAY = "TP_SET_OVERLAY";
